/* Syrup Oracle: recipe tools.
   Wires "Batch this recipe" links on recipe cards by converting the card's
   ingredient rows into the batching calculator's v3 share-link format
   (?bc=<base64 json>), so any recipe opens pre-loaded in the calculator. */
(function () {
  'use strict';
  if (window.soRecipeToolsLoaded) return;
  window.soRecipeToolsLoaded = true;

  var FRACTIONS = { '¼': 0.25, '½': 0.5, '¾': 0.75, '⅓': 0.333, '⅔': 0.667, '⅛': 0.125 };
  var UNIT_MAP = {
    oz: 'oz', ounce: 'oz', ounces: 'oz',
    ml: 'ml',
    tsp: 'tsp', teaspoon: 'tsp', teaspoons: 'tsp', barspoon: 'tsp', barspoons: 'tsp',
    tbsp: 'tbsp', tablespoon: 'tbsp', tablespoons: 'tbsp',
    dash: 'dash', dashes: 'dash', drop: 'dash', drops: 'dash'
  };

  function parseAmount(raw) {
    var s = (raw || '').trim().toLowerCase();
    var num = 0, matched = false;
    var m = s.match(/^(\d+)?\s*([¼½¾⅓⅔⅛])?/);
    if (m && (m[1] || m[2])) {
      matched = true;
      if (m[1]) num += parseInt(m[1], 10);
      if (m[2]) num += FRACTIONS[m[2]];
    } else {
      var d = s.match(/^(\d*\.?\d+)/);
      if (d) { num = parseFloat(d[1]); matched = true; }
    }
    if (!matched || !num) num = 1;
    var unit = 'oz';
    var u = s.match(/(fl\s*oz|oz|ounces?|ml|tsp|teaspoons?|barspoons?|tbsp|tablespoons?|dash(?:es)?|drops?)/);
    if (u) unit = UNIT_MAP[u[1].replace(/\s+/g, ' ').replace('fl ', '')] || 'oz';
    return { am: Math.round(num * 1000) / 1000, u: unit };
  }

  function buildBatchUrl(calcUrl, name, rows) {
    var ings = rows.map(function (r) {
      var parsed = parseAmount(r.amount);
      return { nm: r.name, am: parsed.am, u: parsed.u };
    });
    var state = {
      v: 3, n: name, g: 1, dp: 1, ss: 'full', pm: 'full', pb: false,
      dil: 0.2, adv: false, wst: 0, ou: 'oz', ings: ings
    };
    return calcUrl + '?bc=' + btoa(encodeURIComponent(JSON.stringify(state)));
  }

  function wire(root) {
    var cards = (root || document).querySelectorAll('[data-so-batchable]');
    Array.prototype.forEach.call(cards, function (card) {
      var link = card.querySelector('[data-so-batch-link]');
      if (!link || link.getAttribute('data-so-wired')) return;
      var name = card.getAttribute('data-drink-name') || 'Recipe';
      var calcUrl = card.getAttribute('data-calc-url') || '/pages/batch-cocktail-calculator';
      var rows = [];
      card.querySelectorAll('.so-recipe__ingredients li').forEach(function (li) {
        var nameEl = li.querySelector('span:first-child');
        var amtEl = li.querySelector('.amt');
        if (nameEl && amtEl) rows.push({ name: nameEl.textContent.trim(), amount: amtEl.textContent.trim() });
      });
      if (!rows.length) return;
      try {
        link.href = buildBatchUrl(calcUrl, name, rows);
        link.removeAttribute('hidden');
        link.setAttribute('data-so-wired', '1');
      } catch (e) { /* leave hidden */ }
    });
  }

  window.soWireBatchLinks = wire;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { wire(); });
  } else {
    wire();
  }
})();
